export default __webpack_public_path__ + "static/media/privacy_policy.b56e79f7.pdf";